module.exports = __webpack_public_path__ + "static/media/08(3).a89ead15.jpg";